<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >

    <el-dialog
      :visible="dialogVisible"
      title="新建结算"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" :rules="rules" ref="form" label-width="160px">
        <el-form-item prop="leagueId" label="门派">
          <el-select v-model="detail.leagueId" placeholder="请选择">
            <el-option
              v-for="item in list"
              :key="item.id"
              :label="item.name && item.name.zh"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="totalProfit" label="类型">
          <el-select v-model="rankingType" placeholder="请选择">
            <el-option label="掌门" :value="0"></el-option>
            <el-option label="普通弟子" :value="9999"></el-option>
            <el-option label="其他排名" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-show="![0, 9999].includes(rankingType)"
          prop="ranking"
          label="名次"
        >
          <el-input type="number" v-model="detail.ranking"></el-input>
        </el-form-item>

        <el-form-item prop="name" label="称号">
          <el-input v-model="detail.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';
import math from 'common/math';

export default {
  name: 'leagueCreate',
  data() {
    return {
      dialogVisible: false,
      rankingType: 0,
      detail: {
        ranking: 0
      },
      rules: {
        leagueId: { required: true, message: '请填写' },
        ranking: { required: true, message: '请填写' },
        name: { required: true, message: '请填写' }
      },
      math
    };
  },
  computed: {
    ...mapState('league', ['list'])
  },
  watch: {
    rankingType: {
      handler(val, oldVal) {
        if (val != oldVal) {
          if ([0, 9999].includes(val)) {
            this.detail.ranking = val;
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('leagueLabel', ['createLabel']),
    ...mapActions('league', ['getConfig', 'getList']),
    closeDialog() {
      this.dialogVisible = false;
      this.rankingType = 0;
      this.detail = {
        ranking: 0
      };
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      this.createLabel({
        leagueId: this.detail.leagueId,
        ranking: this.detail.ranking,
        name: this.detail.name
      }).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
